const masks = {
  yearMonthDay: [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
  monthDayYear: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
};

export const date = {
  default: masks.monthDayYear,
  ...masks
};
